import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { API_URL } from "../../server";
import BotIntegration from "../BotIntegration/BotIntegration";
import LoopEightbody from "./loopEight";
import LoopFivebody from "./loopFive";
import LoopFourbody from "./loopFour";
import LoopNinebody from "./loopNine";
import LoopOnebody from "./LoopOne";
import LoopSevenbody from "./loopSeven";
import LoopSixbody from "./loopSix";
import LoopThreebody from "./loopThree";
import { IMG_PATH } from "../../server";
import LoopTwobody from "./loopTwo";
import Aitwin from "../../Assets/images/Frame.png";
import rightarrow from "../../Assets/images/rightarrow.png";

import "./loopview.css";

const Loopview = ({
  data,
  onNext,
  stepName,
  totalSteps,
  index,
  closeModal,
  courseId,
  subject,
  articles,
  onToggleChat,
  selectedTutor,
  selectedTutorId = null,
  answerId = null,
  currentOutlineDetail,
}) => {
  const [animateClass, setAnimateClass] = useState("animate-slide");
  const [comment, setComment] = useState("");
  const [selectSkill, setSelectSkill] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [experts, setExperts] = useState([]);
  const [tutorName, setTutorName] = useState("Tutor");
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [botId, setBotId] = useState("");

  const isLastStep = index === 4;

  const formRef = useRef({
    selectskill: localStorage.getItem("selectskill") || "",
    selectOption: localStorage.getItem("selectOption") || "",
    activitytext: localStorage.getItem("activitytext") || "",
    startcount: parseInt(localStorage.getItem("startcount")) || 0,
    comment: localStorage.getItem("comment") || "",
    nextstep: localStorage.getItem("nextstep") || "",
  });

  const resolvedTutorId =
    selectedTutorId ||
    selectedTutor?.expertId ||
    selectedTutor?._id ||
    selectedTutor?.user_id ||
    null;

  const resolvedAnswerId =
    answerId || currentOutlineDetail?.Answer?.[0]?._id || null;

  const isBookingFlow = Boolean(
    resolvedTutorId && resolvedAnswerId && courseId,
  );

  // ✅ Persist tutor selection
  const selectedTutorRef = useRef(null);

  useEffect(() => {
    if (selectedTutor) {
      selectedTutorRef.current = selectedTutor;
      setTutorName(selectedTutor.fullName || selectedTutor.name || "Tutor");
    }
  }, [selectedTutor]);

  useEffect(() => {
    if (selectedTutorRef.current) {
      setTutorName(
        selectedTutorRef.current.fullName ||
          selectedTutorRef.current.name ||
          "Tutor",
      );
      return;
    }

    const registerid = sessionStorage.getItem("registerid");
    console.log("registerid:-", registerid);

    const fetchExperts = async () => {
      try {
        const headers = new Headers({ "Content-Type": "application/json" });
        const response = await fetch(
          "https://learnatrecess.com:7001/getAllApprovedExpertProfile",
          {
            method: "POST",
            headers,
            body: JSON.stringify({ user_id: registerid }),
          },
        );

        const result = await response.json();
        const expertList = result.data || result;
        setExperts(expertList);

        if (!expertList || expertList.length === 0) {
          setTutorName("Tutor");
          return;
        }

        if (subject) {
          const lowerSubject = subject.toLowerCase();

          const botTutors = expertList
            .map((exp) => exp.botdata || (exp.bot_id ? exp : null))
            .filter(
              (bot) =>
                bot &&
                bot.mySubject?.some((sub) =>
                  sub.toLowerCase().includes(lowerSubject),
                ),
            );

          const sortedBots = botTutors.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
          );

          const latestTutor =
            sortedBots.length > 0 ? sortedBots[0] : { name: "Tutor" };

          selectedTutorRef.current = latestTutor;
          setTutorName(latestTutor.fullName || latestTutor.name || "Tutor");

          console.log(
            "Latest bot tutor:",
            latestTutor.name,
            latestTutor.createdAt,
          );
        }
      } catch (error) {
        console.error("Error fetching experts:", error);
        toast.error("Failed to load experts");
        setTutorName("Tutor");
      }
    };

    fetchExperts();
  }, [subject, selectedTutor]);

  useEffect(() => {
    setAnimateClass("");
    const timeout = setTimeout(() => setAnimateClass("animate-slide"), 10);
    return () => clearTimeout(timeout);
  }, [data]);

  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false; // mark unmounted
    };
  }, []);

  const updateField = (field, value) => {
    formRef.current[field] = value;
    localStorage.setItem(field, value);

    if (["Writing", "Communication"].includes(value)) setSelectSkill(value);
    if (["Option A", "Option B"].includes(value)) setSelectedOption(value);
  };

  const handleFeedbackClick = () => {
    const tutor = selectedTutorRef.current;

    const assignedBotId =
      tutor?.bot_id || tutor?.botdata?.bot_id || data?.bot_id || null;

    if (!assignedBotId) {
      toast.error("This tutor has no bot assigned.");
      return;
    }

    console.log("Opening chat with bot:", assignedBotId);

    setBotId(assignedBotId);
    onToggleChat?.(assignedBotId);
    setIsChatOpen((prev) => !prev);
  };

  const renderStepComponent = () => {
    switch (index) {
      case 0:
        return (
          <LoopOnebody
            data={data}
            setSelectSkill={(val) => updateField("selectskill", val)}
            selectSkill={selectSkill}
          />
        );
      case 1:
        return (
          <LoopTwobody
            data={data}
            onQuizComplete={(passed) => {
              if (passed) {
                handleNext();
              }
            }}
            onAskTutor={handleFeedbackClick} // ✅ ADD THIS
            tutorName={tutorName} // ✅ ADD THIS
            isChatOpen={isChatOpen} // ✅ ADD THIS
          />
        );
      case 2:
        return <LoopThreebody data={data} />;
      case 3:
        return (
          <LoopFourbody
            data={data}
            tutorName={tutorName}
            subject={subject}
            setSelectOption={(val) => updateField("selectOption", val)}
            selectedOption={selectedOption}
          />
        );
      case 4:
        return <LoopFivebody data={data} />;
      case 5:
        return (
          <LoopSixbody
            data={data}
            setActivityText={(val) => updateField("activitytext", val)}
            tutorName={tutorName}
            selectedTutorRef={selectedTutorRef}
          />
        );
      case 6:
        return <LoopEightbody data={data} />;
      case 7:
        return (
          <LoopNinebody
            data={data}
            setNextStep={(val) => updateField("nextstep", val)}
            subject={subject}
            articles={articles}
            experts={experts}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    console.log("Loopview props debug => selectedTutorId:", selectedTutorId);
    console.log("Loopview props debug => answerId:", answerId);
    console.log("Loopview props debug=>  data._id (loop item):", data?._id);
    console.log("📘 Course ID from Loopview:", courseId);
    console.log(
      "Loopview props debug => currentOutlineDetail.Answer[0]._id:",
      currentOutlineDetail?.Answer?.[0]?._id,
    );
  }, [selectedTutorId, answerId, data, currentOutlineDetail]);

  const createLoopSession = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const registerid = sessionStorage.getItem("registerid");

      const payload = {
        user_id: registerid,
        expert_id: selectedTutorId,
        courseId: courseId,
        answerId: answerId || (data?._id ?? null),
      };

      const res = await fetch(API_URL + "createLoopSession", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (isMounted.current) {
        if (result.Status === true) {
          // toast.success("Loop completed successfully!", { autoClose: 2000 });
        } else {
          toast.error(result?.message || "Failed to record loop session");
        }
      }

      return result;
    } catch (error) {
      if (isMounted.current) {
        console.error("❌ createLoopSession error:", error);
        toast.error("Network error");
      }
    }
  };

  const handleNext = async () => {
    formRef.current.comment = comment;

    // If we're on the last step
    if (index === totalSteps - 1) {
      console.log("✅ LAST STEP reached");

      if (!selectedTutorId) {
        console.log("⚠️ No tutor selected, skipping API call");
        closeModal(); // just close the modal
        onNext?.(); // optional parent logic
        return;
      }

      console.log("🚀 Calling createLoopSession...");
      try {
        const result = await createLoopSession(); // wait for API

        if (result && result.Status === true) {
          console.log("✅ Loop session created successfully");
          onNext?.(); // parent step logic
          closeModal(); // close modal after success
        } else {
          console.warn("⚠️ Loop session failed, stay on last step");
          // toast already handled in createLoopSession
        }
      } catch (err) {
        console.error("❌ Error creating loop session:", err);
        // stay on last step
      }

      return;
    }

    // Normal step navigation
    onNext();
  };

  return (
    <div className={`stepviewConatiner ${animateClass}`}>
      {/* ❌ Hide header on last step */}
      {!isLastStep && (
        <>
          <div className="card-headers">
            <span className="section">Section {index + 1}</span>
            <span className="stepscount">{stepName}</span>
          </div>
          <hr className="my-3 border-t-2 border-[#BABABA]" />
        </>
      )}

      {/* Chat modal */}
      {isChatOpen && (
        <BotIntegration botId={botId} userId="currentUser@example.com" />
      )}

      <div className="card-body">{renderStepComponent()}</div>

      {/* ✅ NORMAL STEPS */}
      {!isLastStep && index !== 1 && (
        <div className="card-footer flex flex-col gap-3">
          <button
            onClick={handleFeedbackClick}
            className="btn w-100 flex items-center justify-center gap-2 border border-black "
          >
            <img src={Aitwin} alt="icon" className="w-4 h-4 object-contain" />

            {index === 0
              ? isChatOpen
                ? `Close Chat with ${tutorName}`
                : `Ask ${tutorName} a Question`
              : index === 2
                ? isChatOpen
                  ? `Close Chat with ${tutorName}`
                  : `Ask ${tutorName} for Help`
                : index === 3
                  ? isChatOpen
                    ? `Close Chat with ${tutorName}`
                    : `Chat with ${tutorName}`
                  : null}
          </button>

          <button
            onClick={handleNext}
            className="btn btn-dark w-100 d-flex align-items-center justify-content-center gap-2"
          >
            {index === 0
              ? "Check Your Understanding"
              : index === 3
                ? "Complete Loop"
                : "Continue to Support"}

            <img
              src={rightarrow}
              alt="icon"
              className="w-4 h-4 object-contain"
            />
          </button>
        </div>
      )}

      {/* ✅ LAST STEP (ONLY DONE BUTTON) */}
      {isLastStep && (
        <div className="card-footer">
          <button
            onClick={handleNext}
            className="btn btn-dark w-100 d-flex align-items-center justify-content-center gap-2"
          >
            Done
            <img
              src={rightarrow}
              alt="icon"
              className="w-4 h-4 object-contain"
            />
          </button>
        </div>
      )}
    </div>
  );
};

export default Loopview;
